import {defineMessages} from 'react-intl';

export const messages = defineMessages({
    YES: {
        id: 'techDoc.immobilizedVehicle.option.yes',
        defaultMessage: 'Yes'
    },
    NO: {
        id: 'techDoc.immobilizedVehicle.option.no',
        defaultMessage: 'No'
    },
});

export default messages;
